import { Component, Injector, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { PageConfigurationInterface } from 'src/app/core/interfaces/api/page-configuration';
import { BootstrapModalService } from 'src/app/core/services/ui/bootstrap-modal.service';

@Component({
  selector: 'app-page-configuration-modal',
  templateUrl: './page-configuration-modal.component.html',
})
export class PageConfigurationModalComponent implements OnInit {
  public data$: Observable<PageConfigurationInterface> =
    this._bsModalService.getDataIssued();

  public injector: Injector;

  constructor(
    private _bsModalService: BootstrapModalService<PageConfigurationInterface>,
    private parentInjector: Injector
  ) {
    let password: string | undefined = '';
    this.data$.subscribe((data) => {
      password = data?.password;
    });
    this.injector = Injector.create({
      providers: [{ provide: 'password', useValue: password }],
      parent: this.parentInjector,
    });
  }

  ngOnInit(): void {}

  public closeModal(): void {
    this._bsModalService.closeModal();
  }
}
